// action types

// peers
export const ADD_PEER = "ADD_PEER";
export const REMOVE_PEER = "REMOVE_PEER";

// blockchain
export const ADD_BLOCK = "ADD_BLOCK";
export const MUTATE_DATA = "MUTATE_DATA";
export const RE_MINE = "RE_MINE";
export const REPLACE_CHAIN = "REPLACE_CHAIN";

// p2p
export const CONNECT_PEER = "CONNECT_PEER";
export const DISCONNECT_PEER = "DISCONNECT_PEER";
export const ADD_MESSAGE = "ADD_MESSAGE";

export const REQUEST_LATEST_BLOCK = "REQUEST_LATEST_BLOCK";
export const RECEIVE_LATEST_BLOCK = "RECEIVE_LATEST_BLOCK";
export const REQUEST_BLOCKCHAIN = "REQUEST_BLOCKCHAIN";
export const RECEIVE_BLOCKCHAIN = "RECEIVE_BLOCKCHAIN";
export const REQUEST_TRANSACTIONS = "REQUEST_TRANSACTIONS";
export const RECEIVE_TRANSACTIONS = "RECEIVE_TRANSACTIONS";

// transactions
export const ADD_TRANSACTION = "ADD_TRANSACTION";
export const REMOVE_TRANSACTION = "REMOVE_TRANSACTION";

// tour
export const CHANGE_STEP = "CHANGE_STEP";

// action creators
export function addPeer() {
  return {
    type: ADD_PEER
  };
}

export function removePeer(peer) {
  return {
    type: REMOVE_PEER,
    peer
  };
}

export function addBlock(block, peer) {
  console.log(block, peer);
  return {
    type: ADD_BLOCK,
    block,
    peer
  };
}

export function mutateData(peer, blockIndex, data) {
  return {
    type: MUTATE_DATA,
    peer,
    blockIndex,
    data
  }
}

export function reMine(index, peer, nonce, hash, timestamp) {
  return {
    type: RE_MINE,
    index,
    nonce,
    hash,
    timestamp,
    peer
  };
}

export function addTransaction(transaction) {
  return {
    type: ADD_TRANSACTION,
    transaction
  }
}

export function removeTransaction(transaction) {
  return {
    type: REMOVE_TRANSACTION,
    transaction
  }
}

export function connectPeer(fromPeer, toPeer) {
  return {
    type: CONNECT_PEER,
    fromPeer,
    toPeer
  }
}

export function disconnectPeer(fromPeer, toPeer) {
  return {
    type: DISCONNECT_PEER,
    fromPeer,
    toPeer
  }
}

export function replaceChain(chain, peer) {
  return {
    type: REPLACE_CHAIN,
    chain,
    peer
  }
}

export function addMessage(fromPeer, toPeer, message) {
  return {
    type: ADD_MESSAGE,
    fromPeer,
    toPeer,
    message
  }
}

export function changeStep(step) {
  return {
    type: CHANGE_STEP,
    step
  }
}


// WEBPACK FOOTER //
// ./src/actions.js